module.exports = __webpack_public_path__ + "img/business-card.e76ff47d.svg";